import { render, staticRenderFns } from "./CorpusAnnotationDetail.vue?vue&type=template&id=29f95ed2&scoped=true&"
import script from "./CorpusAnnotationDetail.vue?vue&type=script&lang=ts&"
export * from "./CorpusAnnotationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CorpusAnnotationDetail.vue?vue&type=style&index=0&id=29f95ed2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f95ed2",
  null
  
)

export default component.exports